export default __webpack_public_path__ + "static/media/result-image.16e08b5f.svg";